import { getFrontendConfigLoader } from '@doxyme/config';
import { GrowthBook } from '@growthbook/growthbook';

import { getGrowthBookAttributes } from './getGrowthBookAttributes';

const GROWTH_BOOK_API_HOST = 'https://cdn.growthbook.io';

let _growthBookInstance: GrowthBook | undefined;

// This returns a private growthbook instance, used for internal purposes,
// do not use it growthbook instance directly, use the growthbook config loader instead
export const _getGrowthBookInstance = async (): Promise<GrowthBook> => {
  return (_growthBookInstance ??= new GrowthBook({
    apiHost: GROWTH_BOOK_API_HOST,
    clientKey: getFrontendConfigLoader().get(
      'GROWTH_BOOK_CLIENT_KEY',
    ) as string,
    attributes: await getGrowthBookAttributes(),
  }));
};
